
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container" [hidden]="!workflowTargetInfo.correctRole" [ngClass]="{'general-disabled': order?.isMigrationActive}">
  <div class="row alert-container-block">
    <div class="col">
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Enter order details:</p>
      </div>
    </div>
  </div>
  <div class="form" *ngIf="order" [formGroup]="order.form">
    <div class="row justify-content-md-center">
      <div class="col-md-10 card-block">
        <div class="row">
          <div class="form-group col">
            <label class="required" for="orderName">Name:</label>
            <input class="form-control" id="orderName" formControlName="name" name="name" maxlength="100" required>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-lg-6">
            <label class="required" for="orderShippingDestination">Shipping Destination</label>
            <select class="form-control" id="orderShippingDestination" formControlName="shippingDestination" name="shippingDestination" required>
              <option *ngFor="let property of shippingDestinationValues" [value]="property[0]">{{property[1]}}</option>
              <option value=""></option>
            </select>
          </div>
          <div class="form-group col-lg-6">
            <label class="required" for="orderDeliveryMethod">Delivery Method</label>
            <select class="form-control" id="orderDeliveryMethod" formControlName="deliveryMethod" name="deliveryMethod" required>
              <option *ngFor="let property of deliveryMethodValues" [value]="property[0]">{{property[1]}}</option>
              <option value=""></option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <div class="inline-block">
              <label for="estimatedHardwareOrderDate">Estimated Hardware Order Date:
                <help-dialog-button fieldName="Estimated Hardware Order Date" helpString="The equipment order should be submitted for processing by this date"></help-dialog-button>
              </label>
            </div>
            <div class="input-group">
              <input class="form-control" id="estimatedHardwareOrderDate" formControlName="estimatedHardwareOrderDate" name="estimatedHardwareOrderDate" type="text" (change)="txtToDP('estimatedHardwareOrderDate')">
              <datepicker class="right input-group-append" id="estimatedHardwareOrderDatePicker" formControlName="estimatedHardwareOrderDatePicker" name="estimatedHardwareOrderDatePicker" (outputEvents)="DPToTxt('estimatedHardwareOrderDate')"></datepicker>
            </div>
          </div>
          <div class="col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
            <div class="inline-block">
              <label for="requestedDeliveryDate">Customer Requested Delivery Date (CRDD in S4):</label>
            </div>
            <div class="input-group">
              <input class="form-control" id="requestedDeliveryDate" formControlName="requestedDeliveryDate" name="requestedDeliveryDate" type="text" (change)="txtToDP('requestedDeliveryDate')">
              <datepicker class="right input-group-append" id="requestedDeliveryDatePicker" formControlName="requestedDeliveryDatePicker" name="requestedDeliveryDatePicker" (outputEvents)="DPToTxt('requestedDeliveryDate')"></datepicker>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="inline-block">
              <label for="sourceName">Source Name:</label>
            </div>
            <div class="input-group">
              <input class="form-control" id="sourceName" formControlName="sourceName" name="sourceName" type="text" maxlength="60">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="inline-block">
              <label for="sourceDocumentationLink">Source Documentation Link:</label>
            </div>
            <div class="input-group">
              <input class="form-control" id="sourceDocumentationLink" formControlName="sourceDocumentationLink" name="sourceDocumentationLink" type="text" maxlength="2000">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group col">
            <label class="control-label" for="orderDeliveryInformation">Delivery Information</label>
            <textarea class="form-control" id="orderDeliveryInformation" formControlName="deliveryInformation" name="deliveryInformation" maxlength="300"></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>